<ng-container [ngTemplateOutlet]="introTmpl"></ng-container>
<div class="signature-main-block">
    <p class="label">Signature</p>
    <div class="signature-container" #signatureContainer>
        <signature-pad #signatureCanvas [options]="options" (drawEnd)="drawComplete()"></signature-pad>
    </div>
    <div class="footer" *ngIf="editable">
        <button type="button" (click)="clearSignature()" class="clear">Clear</button>
        <p class="hint">Sign above</p>
    </div>
</div>
